<section id="about" >
  <div class="container">


  <header class="section-header">
    <h1 class="section-title" style="text-align: center;">Marketing Management Software</h1>
  </header>
  <div class="row row-eq-height justify-content-center">
      <div class="row about-container">

        
          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
           
            <div class="icon-box wow fadeInUp">
              <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Product</a></h4>
              <p class="description">You can create a range of Product.</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Customer</a></h4>
              <p class="description">You can create a Customer with City, Detailed
                  address and phone number.</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">City</a></h4>
              <p class="description">You can create a multiple Cities.
                </p>
            </div>

            <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">User</a></h4>
                <p class="description">You can get secured with user name and password
                    creation. </p>
              </div>

              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Quotation Prepartion</a></h4>
                  <p class="description">You can prepare detailed Quotation with
                      terms & conditions.</p>
                </div>
                <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Enquiry</a></h4>
                  <p class="description">You can maintain detailed enquiry with
                      Name of Organization, Product name, Address
                      City, Contact person, Price quoted, Quotation
                      date. Last follow-up date, next follow up date.
                    </p>
                </div>
                <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Reports</a></h4>
                  <p class="description">Product wise Enquiry register,
                      City wise Enquiry register,
                      Customer wise Enquiry register,
                      Next follow up Date wise Enquiry Register.
                      All Enquiries,
                      Product wise Quotation Register,
                      Customer wise Quotation Register,
                      City wise Enquiry register,
                      Next follow up Date wise Enquiry Register,
                      All Quotation list.
                    </p>
                </div>
              
          </div>
         


          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
                      
          </div>
        </div>

        
    </div>
</div>
</section>